import axios from '@api/axiosInstance.js'

export const fetchAuthToken = async (token) => {
  const res = await axios.post(
    '/auth/token',
    {},
    {
      headers: {
        Authorization: `Bearer ${token}`
      },
      withCredentials: true
    }
  )
  return res.data
}

export const fetchAuthTokenWithCompanyCode = async (companyCode) => {
  const res = await axios.get(`/auth/login`, {
    params: { companyCode },
    withCredentials: true
  })

  return res.data
}

export const fetchServerTime = async (payload = {}) => {
  const res = await axios.post(`/system/server-time`, payload)
  return res.data
}

export const fetchOrgInfo = async (payload = {}) => {
  const res = await axios.post(`/org/info`, payload)
  return res.data
}

export const fetchCoinAll = async (payload = {}) => {
  const res = await axios.post('/coin/all', payload)
  return res.data
}

export const fetchCurrentCoinPrice = async ({ assetIds }) => {
  const res = await axios.post('/coin/price', { assetIds })
  return res.data
}
